import { Eye, Pencil, Trash2 } from "lucide-react";

interface RowActionsProps {
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

const btnBase =
  "inline-flex h-7 w-7 items-center justify-center rounded-md bg-transparent text-muted-foreground transition-[background,color] duration-150 hover:bg-muted hover:text-foreground";

const btnDelete =
  "inline-flex h-7 w-7 items-center justify-center rounded-md bg-transparent text-muted-foreground transition-[background,color] duration-150 hover:bg-[hsl(0,70%,95%)] hover:text-[hsl(0,84%,50%)]";

export function RowActions({ onView, onEdit, onDelete }: RowActionsProps) {
  return (
    <div className="flex items-center justify-end gap-1">
      <button
        type="button"
        className={btnBase}
        title="View"
        onClick={(e) => {
          e.stopPropagation();
          onView();
        }}
      >
        <Eye className="h-[15px] w-[15px]" strokeWidth={1.5} />
      </button>
      <button
        type="button"
        className={btnBase}
        title="Edit"
        onClick={(e) => {
          e.stopPropagation();
          onEdit();
        }}
      >
        <Pencil className="h-[15px] w-[15px]" strokeWidth={1.5} />
      </button>
      <button
        type="button"
        className={btnDelete}
        title="Delete"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
      >
        <Trash2 className="h-[15px] w-[15px]" strokeWidth={1.5} />
      </button>
    </div>
  );
}
